import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { observer } from 'mobx-react';
import { TextSkeleton } from '@udemy-v2/react-reveal-components';
import { useClpPurchaseContext } from '../../context/clp-purchase-context.react-component';
import { ClpSubscriptionUnpause } from '../clp-subscription-unpause/clp-subscription-unpause.react-component';
import { CollapsibleBuyBox } from '../buy-box/collapsible-buy-box.react-component';
import { CourseSidebarNoTabsContainer } from './course-sidebar-no-tabs-container.react-component';
import { CourseSidebarCollapsibleActionsContainer } from './course-sidebar-collapsible-actions-container.react-component';
import { CourseSidebarTabsContainer } from './course-sidebar-tabs-container.react-component';
import { CourseContentPlacement } from '@/features/course-landing-page/course-landing-page.react-component';
import styles from './course-sidebar-container.module.scss';
export const SIDEBAR_PREVIEW_UI_REGION = 'sidebar.introductionAsset';
export const CourseSidebarContainerSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.container}><TextSkeleton className={styles.skeleton} withTitle={true} lineCountPerParagraph={3} paragraphCount={4} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
interface CourseSidebarContentProps {
  placement: CourseContentPlacement;
  personalContent: React.ReactNode;
  teamsContent: React.ReactNode;
  renderTabContainer: boolean;
  useCollapsiblePurchaseSection?: boolean;
}

/**
 * CourseSidebarContent - handles the reactive loading/content logic
 * This component is wrapped with observer to react to MobX changes
 */
const CourseSidebarContentInternal = t0 => {
  const $ = _c(11);
  const {
    placement,
    personalContent,
    teamsContent,
    renderTabContainer,
    useCollapsiblePurchaseSection
  } = t0;
  const {
    isLoading,
    isConsumerSubscriptionPaused,
    isCourseIncludedInGrowWithGoogleSubscription,
    isCourseInAvailablePlans,
    isEligibleForNonCatalogPPOffer,
    removeSubscriptionOptionEnabled
  } = useClpPurchaseContext();
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CourseSidebarContainerSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (isConsumerSubscriptionPaused && !useCollapsiblePurchaseSection && !isCourseIncludedInGrowWithGoogleSubscription) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ClpSubscriptionUnpause />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = !removeSubscriptionOptionEnabled && (isCourseInAvailablePlans || isEligibleForNonCatalogPPOffer);
    let t3;
    if ($[2] !== t2) {
      t3 = <div className={styles.container}>{t1}<div className={styles["collapsible-container"]}><CollapsibleBuyBox showRadio={t2} /></div></div>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  if (renderTabContainer) {
    let t1;
    if ($[4] !== personalContent || $[5] !== placement || $[6] !== teamsContent) {
      t1 = <CourseSidebarTabsContainer personalContent={personalContent} teamsContent={teamsContent} placement={placement} />;
      $[4] = personalContent;
      $[5] = placement;
      $[6] = teamsContent;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  if (useCollapsiblePurchaseSection) {
    let t1;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CourseSidebarCollapsibleActionsContainer />;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    return t1;
  }
  let t1;
  if ($[9] !== placement) {
    t1 = <CourseSidebarNoTabsContainer placement={placement} />;
    $[9] = placement;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
};
const CourseSidebarContent = observer(CourseSidebarContentInternal);
interface CourseSidebarContainerProps {
  placement: CourseContentPlacement;
  personalContent: React.ReactNode;
  teamsContent: React.ReactNode;
  renderTabContainer: boolean;
  useCollapsiblePurchaseSection?: boolean;
}

/**
 * CourseSidebarContainer - wraps sidebar purchase content
 * CoursePreviewEntryPoint is now rendered at the parent level to avoid re-renders
 * from design system's useViewport hooks in SidebarPopout/SidebarNormalFlow
 */
export function CourseSidebarContainer(t0) {
  const $ = _c(6);
  const {
    placement,
    personalContent,
    teamsContent,
    renderTabContainer,
    useCollapsiblePurchaseSection
  } = t0;
  let t1;
  if ($[0] !== personalContent || $[1] !== placement || $[2] !== renderTabContainer || $[3] !== teamsContent || $[4] !== useCollapsiblePurchaseSection) {
    t1 = <CourseSidebarContent placement={placement} personalContent={personalContent} teamsContent={teamsContent} renderTabContainer={renderTabContainer} useCollapsiblePurchaseSection={useCollapsiblePurchaseSection} />;
    $[0] = personalContent;
    $[1] = placement;
    $[2] = renderTabContainer;
    $[3] = teamsContent;
    $[4] = useCollapsiblePurchaseSection;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}